import { Component, Input } from "@angular/core"
import { PremiumSectionItem } from "../../../models/collection/premiumSectionItem.model"
import { GlobalStoreService } from "../../../services/global-store.service"
import { WindowSizeService } from "../../../services/window-size.service"
import Utils from "../../../utils/utils"

@Component({
    selector: "app-mezzanine-collection-card",
    templateUrl: "./mezzanine-collection-card.component.html",
    styleUrls: ["./mezzanine-collection-card.component.scss"],
    standalone: false,
})
export class MezzanineCollectionCardComponent {
    public premiumSectionItem: PremiumSectionItem
    public imageURL: string
    public imageAlt: string = "Open"
    @Input() public sectionName: string = ""

    constructor(
        public windowSize: WindowSizeService,
        private globalStoreService: GlobalStoreService
    ) {}

    @Input()
    public set item(value: PremiumSectionItem) {
        this.premiumSectionItem = value
        this.imageAlt = value.imageAlt ? value.imageAlt : this.imageAlt
        this.imageURL = value.image.resize(289 * 2, 162 * 2, this.globalStoreService.imageFormat)
    }

    get subCollectionLink(): string {
        return Utils.isPreviewMode()
            ? this.premiumSectionItem.url + "/preview/"
            : this.premiumSectionItem.url
    }
}
